import React from 'react'
import FormatNumberFuncs from '~/Classes/numberFormatFunctions'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'

export default function LandingPageImpressions({ landingPage }) {
    return (
        <Paper className='paper-padding-24'>
            <div className='quickFlex' style={{ gap: 16 }}>
                <Icons
                    icon='eye'
                    outerStyle={{
                        borderRadius: 4,
                        backgroundColor: 'var(--indigo-50)',
                        height: 38,
                        width: 38,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    color='var(--indigo-600)'
                    style={{ height: 20, width: 20 }}
                />
                <div>
                    <h4>{FormatNumberFuncs.formatNumber(landingPage.impressions)}</h4>
                    <div
                        style={{
                            fontWeight: 500,
                            fontStyle: 'Medium',
                            fontSize: '14px',
                            lineHeight: '20px'
                        }}
                    >
                        Total Visits
                    </div>
                </div>
            </div>
        </Paper>
    )
}
